export default __webpack_public_path__ + "static/media/storage.b53f9443.svg";